<template>
  <div class="container-fluid-grid" style="overflow-x: hidden;overflow-y: visible">
    <transition name="mode" mode="out-in">
      <div v-if="mode.service === 'normal'" :key="'normal'">
        <div class="form-row">
          <div class="col-12 form-group">
            <label for="invoiceEditServiceItems" class="required">Item da lista de serviços</label>
            <select class="form-control form-control-sm"
                    id="invoiceEditServiceItems"
                    v-model="entity.service_code">
              <option value="100201"
                      label="10.02.01.001 - Agenciamento, corretagem ou intermediação de títulos em geral e valores mobiliários."></option>
              <option value="100202"
                      label="10.02.02.001 - Agenciamento, corretagem ou intermediação de contratos quaisquer."></option>
              <optgroup label="10.09.01 - Representação de qualquer natureza, inclusive comercial.">
                <option value="100901001">10.09.01.001 - Representação comercial especializada</option>
              </optgroup>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 form-group">
            <label for="invoiceEditServicesDesc" class="required">Discriminação do(s) Serviço(s) Prestado(s)</label>
            <textarea class="form-control form-control-sm"
                      :class="{'is-invalid': errors.description}"
                      v-model="entity.description"
                      required
                      maxlength="2000"
                      rows="5"
                      id="invoiceEditServicesDesc"/>
            <small>(caracteres restantes <b>{{ 2000 - entity.description.length }}</b>)</small>
            <field-messages :errors="errors.description"/>
          </div>
        </div>
        <div class="form-row">
          <div v-for="k in Object.keys(valuesOne)" class="col-4 col-md-2 form-group">
            <label :for="`invoiceEditServices${valuesOne[k].label}`"
                   :class="{required: valuesOne[k].required}">{{ valuesOne[k].label }}</label>
            <input type="text"
                   :id="`invoiceEditServices${valuesOne[k].label}`"
                   required
                   :class="{'is-invalid': errors[k]}"
                   @keyup="calculateTaxes($event, k)"
                   v-model="entity[k]"
                   v-money="money"
                   class="form-control form-control-sm t-r">
            <field-messages :errors="errors[k]"/>
          </div>
        </div>
        <div class="form-row">
          <div v-for="k in Object.keys(valuesTwo)" class="col-4 col-md-2 form-group">
            <label :for="`invoiceEditServices${valuesTwo[k].label}`"
                   :class="{required: valuesTwo[k].required}">{{ valuesTwo[k].label }}</label>
            <input type="text"
                   :id="`invoiceEditServices${valuesTwo[k].label}`"
                   required
                   :class="{'is-invalid': errors[k]}"
                   :disabled="!(k === 'csll_value' || (k === 'ir_value' && $appUtils.isCpf(entity.document)))"
                   @keyup="calculateTaxes($event, k)"
                   v-model="entity[k]"
                   v-money="money"
                   class="form-control form-control-sm t-r">
            <field-messages :errors="errors[k]"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-2">
            <label>ISS Retido?</label><br>
            <div style="margin-top: 3px">
              <div class="form-check form-check-inline">
                <input class="form-check-inline checkbox m green"
                       v-model="entity.is_iss_retention"
                       disabled
                       type="checkbox"
                       id="invoiceEditServicesIss">
                <label class="form-check-label c-p f-w-700"
                       for="invoiceEditServicesIss">{{ entity.is_iss_retention ? 'SIM' : 'NÃO' }}</label>
              </div>
            </div>
          </div>
          <div class="form-group col-12 col-md-2">
            <label class="f-w-b">Natureza da Operação</label>
            <input type="text"
                   readonly
                   class="form-control-plaintext form-control-sm"
                   value="Tributação no Município">
          </div>
          <div class="form-group col-12 col-md-4">
            <label class="f-w-b">Regime Especial de Tributação</label>
            <input type="text"
                   readonly
                   class="form-control-plaintext form-control-sm"
                   value="Nenhum">
          </div>
          <div class="form-group col-12 col-md-4">
            <label class="f-w-b">Município da incidência do ISSQN</label>
            <input type="text"
                   readonly
                   class="form-control-plaintext form-control-sm"
                   value="Porto Alegre">
          </div>
        </div>
        <div v-if="orderedProposals.length  > 0">
          <div class="form-row">
            <div class="col-12 t-r" style="padding-bottom: 10px">
              <button type="button" class="btn btn-sm btn-outline-primary" @click="changeMode('proposal')">Selecionar
                Contratos
                <svg-icon icon="chevron-right"/>
              </button>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <table class="table table-hover table-striped table-sm table-bordered">
                <thead class="thead-dark thead-center">
                <tr>
                  <th>#</th>
                  <th>Vendedor</th>
                  <th>Comprador</th>
                  <th>Produto</th>
                  <th>Previsão Pag.</th>
                  <th>Valor</th>
                  <th>Comissão</th>
                  <th style="width: 40px">
                    <button class="btn btn-xs btn-danger"
                            type="button"
                            v-if="Object.keys(selectedProposals).length > 0"
                            title="Remover Todos"
                            @click="() => Object.values(selectedProposals).forEach(v => addDelProposal(v))">
                      <svg-icon icon="trash-alt"/>
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in orderedProposals">
                  <td class="t-c">{{ p.number }}</td>
                  <td>{{ p.seller.name }}</td>
                  <td>{{ p.buyer.name }}</td>
                  <td>{{ p.product.name }}</td>
                  <td class="t-c">{{ p.billing_date | formatDate }}</td>
                  <td class="t-r">{{ p.calculate_total | formatMoney }}</td>
                  <td class="t-r">{{ p.calculate_commission | formatMoney }}</td>
                  <td class="t-c">
                    <button class="btn btn-xs btn-danger"
                            type="button"
                            @click="addDelProposal(p)">
                      <svg-icon icon="trash-alt"/>
                    </button>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td colspan="5" class="t-r f-w-700 c-theme">TOTAL</td>
                  <td class="t-r f-w-700 c-theme">R$ {{ summary.business_total }}</td>
                  <td class="t-r f-w-700 c-theme">R$ {{ summary.commission_total }}</td>
                  <td></td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="form-row" v-else>
          <div class="col-12">
            <br>
            <br>
            <h4 class="t-c">Selecione os contratos para faturar. Clique abaixo.</h4>
            <div class="t-c">
              <button type="button" class="btn btn-sm btn-outline-primary" @click="changeMode('proposal')">Selecionar
                Contratos
                <svg-icon icon="chevron-right"/>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="mode.service === 'proposal'" :key="'proposal'">
        <div class="form-row">
          <div class="col-md-2 col-4 form-group">
            <label for="invoiceEditPropNumber">Número</label>
            <input id="invoiceEditPropNumber" type="text" class="form-control form-control-sm"
                   v-model="search_params.number"/>
          </div>
          <div class="col-md-2 col-4 form-group">
            <label for="invoiceEditPropStart">Período</label>
            <div class="input-group input-group-sm">
              <input type="text"
                     id="invoiceEditPropStart"
                     v-model="search_params.start"
                     placeholder="Início"
                     v-mask="'##/##/####'"
                     v-flatpickr
                     class="form-control form-control-sm t-c plch-center n-m-r-right">
              <div class="input-group-append">
                <div class="input-group-text">
                  <svg-icon icon="calendar-alt"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-4 form-group">
            <label>&nbsp;</label>
            <div class="input-group input-group-sm">
              <input type="text"
                     v-model="search_params.finish"
                     placeholder="Fim"
                     v-mask="'##/##/####'"
                     v-flatpickr
                     class="form-control form-control-sm t-c plch-center n-m-r-right">
              <div class="input-group-append">
                <div class="input-group-text">
                  <svg-icon icon="calendar-alt"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-4 form-group">
            <label for="invoiceEditPropProd">Produto</label>
            <div class="input-group input-group-sm">
              <select id="invoiceEditPropProd"
                      v-model="search_params.product_id"
                      class="form-control form-control-sm">
                <option :value="null">[Todos]</option>
                <option v-for="p in all" :key="p.id" :value="p.id">{{ p.name }}</option>
              </select>

            </div>
          </div>
          <div class="col-md-3 col-4 form-group">
            <label for="invoiceEditPropBilling">Situação</label>
            <div class="input-group input-group-sm">
              <select id="invoiceEditPropBilling"
                      v-model="search_params.billing_status"
                      class="form-control form-control-sm">
                <option :value="null">[Todos]</option>
                <option value="hasInvoice">Faturados</option>
                <option value="nonInvoice">Não Faturados</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 t-r">
                        <span class="btn-group btn-group-sm" role="group">
                        <button type="button"
                                @click="changeMode('normal')"
                                class="btn btn-outline-primary btn-sm"><svg-icon icon="chevron-left"/> Voltar</button>
                        <button type="button"
                                @click="searchProposals(1)"
                                class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                        </span>

          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <br>
            <Pagination
                mode="callback"
                @paging="searchProposals"
                :page_size="search.per_page"
                :current_page="search.current_page"
                :total_entries="search.total_entries"/>
            <table class="table table-hover table-striped table-sm table-bordered">
              <thead class="thead-dark thead-center">
              <tr>
                <th>#</th>
                <th>Vendedor</th>
                <th>Comprador</th>
                <th>Produto</th>
                <th>Previsão Pag.</th>
                <th>Valor</th>
                <th>Comissão</th>
                <th style="width: 40px"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="p in search.entries">
                <td class="t-c">{{ p.number }}</td>
                <td>{{ p.seller.name }}</td>
                <td>{{ p.buyer.name }}</td>
                <td>{{ p.product.name }}</td>
                <td class="t-c">{{ p.billing_date | formatDate }}</td>
                <td class="t-r">{{ p.calculate_total | formatMoney }}</td>
                <td class="t-r">{{ p.calculate_commission | formatMoney }}</td>
                <td class="t-c">
                  <button class="btn btn-xs"
                          type="button"
                          :class="{'btn-danger': selectedProposals[p.id], 'btn-primary': !selectedProposals[p.id]}"
                          @click="addDelProposal(p)">
                    <svg-icon :icon="selectedProposals[p.id] ? 'trash-alt' : 'plus'"/>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import Pagination from "../../components/Pagination";
import Big from "big.js";
import {isMobile} from "../../utils/Utils";

const {mapGetters, mapActions} = createNamespacedHelpers('products');

export default {
  name: "ServicesValueTab",
  components: {
    Pagination
  },
  props: {
    entity: {
      type: Object,
      default: {}
    },
    errors: {
      type: Object,
      default: {}
    },
    mode: {
      type: Object,
      default: {}
    },
    selectedProposals: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      search_params: {
        number: null,
        start: null,
        finish: null,
        product_id: null,
        billing_status: null,
      },
      search: {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
      },
      servicesCodes: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2
      },
      valuesOne: {
        total_value: {label: 'Valor Total', required: true},
        unconditional_discount_value: {label: isMobile() ? 'Valor Incond.' : 'Desc. Incondicionado', required: false}
      },
      valuesTwo: {
        ir_value: {label: 'IRRF (1.5%)', required: true},
        pis_value: {label: 'PIS (0.65%)', required: true},
        cofins_value: {label: 'COFINS (3%)', required: true},
        csll_value: {label: 'CSLL', required: false},
      },
      summary: {
        commission_total: '0,00',
        business_total: '0,00',
      }
    }
  },
  methods: {
    ...mapActions(['loadAll']),
    searchProposals(page = '1') {
      const params = new URLSearchParams();
      params.append('page', page);

      if (!this.$appUtils.isEmpty(this.entity.document))
        params.append('document', this.entity.document.replace(/\D/gi, ''));

      Object.keys(this.search_params).forEach(k => {
        if (this.search_params[k])
          params.append(k, this.search_params[k])
      });

      this.$appHttp.get(`/v1/invoices/search_proposals?${params.toString()}`)
          .then(({data}) => this.search = data)
          .catch(console.error)
    },
    changeMode(mode = 'proposal') {
      if (mode === 'proposal') {
        if (this.$appUtils.isEmpty(this.entity.document))
          this.$snotify.warning('Informe o cliente antes de selecionar contratos.', 'Cliente');
        else {
          this.mode.service = mode;
          this.searchProposals();
        }
      } else {
        this.mode.service = 'normal'
      }
    },
    addDelProposal(p) {
      const quantity = parseFloat(p.quantity_embedded || p.quantity);
      const comission = p.calculate_commission ? `R$ ${this.$appUtils.formatMoney(p.calculate_commission)}` : `${p.percentage_comission}%`;

      const proposalText = `${p.number} ${p.buyer.name} ${quantity} TONS ${p.product.name} ${comission}`;

      if (this.selectedProposals[p.id]) {
        this.$delete(this.selectedProposals, p.id);
        const currentDescription = this.entity.description || '';
        const lines = currentDescription.split('\n');
        const newLines = lines.filter(line => !line.trim().startsWith(p.number));
        this.$set(this.entity, 'description', newLines.join('\n'));
      } else {
        this.$set(this.selectedProposals, p.id, p);
        const currentDescription = this.entity.description || '';
        const newDescription = currentDescription ? `${currentDescription}\n${proposalText}` : proposalText;
        this.$set(this.entity, 'description', newDescription);
      }

      this.calculateTotal();
    },
    loadServicesCodes() {
      this.$appHttp.get('/v1/invoices/load_services_codes')
          .then(({data}) => {
            this.servicesCodes = data.fathers;
          })
          .catch(console.error);
    },
    calculateTotal() {
      let tot = new Big('0');
      let businessTotal = new Big('0');

      Object.keys(this.selectedProposals).forEach(k => {
        const prop = this.selectedProposals[k];
        tot = tot.plus(new Big(prop.calculate_commission));
        businessTotal = businessTotal.plus(new Big(prop.calculate_total));
      });

      this.calculateIr(tot);
      this.calculateCsrf(tot);

      this.summary.commission_total = this.$appUtils.formatMoney(parseFloat(tot.toString()));
      this.summary.business_total = this.$appUtils.formatMoney(parseFloat(businessTotal.toString()));
      this.$set(this.entity, 'total_value', this.summary.commission_total);
    },
    calculateTaxes(e, name) {
      if (/total_value|unconditional_discount_value/.test(name)) {
        const getValue = (value) => parseFloat((value || '').replace(/\./g, '').replace(/,/, '.')) || 0;

        const totalValue = name === 'total_value' ? getValue(e.target.value) : getValue(this.entity.total_value);
        const discountValue = name === 'unconditional_discount_value' ? getValue(e.target.value) : getValue(this.entity.unconditional_discount_value);

        const baseValue = new Big((totalValue - discountValue).toString());
        this.calculateIr(baseValue);
        this.calculateCsrf(baseValue);
      }
    },
    calculateIr(tot) {
      const rounded = new Big(tot.toString()).round(2, 1);
      const ir = rounded.times('0.015');


      this.$set(this.entity, 'ir_value',
          rounded.gte('670') ? this.$appUtils.formatMoney(parseFloat(ir.round(2, 1).toString())) : null
      );

      this.calculateEquityValue(rounded);
    },
    calculateCsrf(tot) {
      const rounded = new Big(tot.toString()).round(2, 1);
      const shouldCalculate = rounded.gte('670');

      const values = shouldCalculate ? {
        pis_value: this.$appUtils.formatMoney(parseFloat(tot.times('0.0065').toString())),
        cofins_value: this.$appUtils.formatMoney(parseFloat(tot.times('0.03').round(2, 1).toString()))
      } : {
        pis_value: null,
        cofins_value: null
      };

      Object.keys(values).forEach(key => this.$set(this.entity, key, values[key]));
    },
    calculateEquityValue(baseValue) {
      let equity = new Big(baseValue.toString());

      if (this.entity.ir_value) {
        const irValue = new Big(this.$appUtils.moneyToFloat(this.entity.ir_value).toString());
        equity = equity.minus(irValue);
      }

      this.$set(this.entity, 'equity_value', this.$appUtils.formatMoney(parseFloat(equity.toString())));
    }
  },
  computed: {
    ...mapGetters(['all']),
    orderedProposals() {
      const result = [];
      Object.keys(this.selectedProposals).sort().forEach(k => result.push(this.selectedProposals[k]));

      return result;
    },
    orderedServiceCodes() {
      const result = [];

      if (this.servicesCodes)
        this.servicesCodes.forEach(sc => {
          result.push(sc);
          sc.children.forEach(c => result.push({...c, title: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${c.title}`}));
        });

      return result;
    }
  },
  mounted() {
    this.loadAll();
    this.loadServicesCodes();

    if (this.$route.query.invoice_id && this.$route.query.mode === "replace") {
      const getValue = (value) => parseFloat((value || '0,00').replace(/\./g, '').replace(/,/, '.')) || 0;

      const totalValue = getValue(this.entity.total_value);
      const discountValue = getValue(this.entity.unconditional_discount_value);

      const baseValue = new Big((totalValue - discountValue).toString());
      this.calculateIr(baseValue);
      this.calculateCsrf(baseValue);
      this.calculateTotal();
    }
  }
}
</script>

<style scoped lang="scss">
.mode-enter-active, .mode-leave-active {
  transition: all .2s ease-in-out;
}

.mode-enter {
  transform: translateX(50px);
  opacity: 0;
}

.mode-leave-to {
  transform: translateX(-50px);
  opacity: 0;
}
</style>
